function Slider() {
  const slides = [
    { type: "image", url: "/assets/homeSlider/Slide1.jpg" },
    { type: "video", url: "/assets/homeSlider/Slide2.mp4" },
  ];

  return (
    <div className="slider">
      {slides.map((slide, index) =>
        slide.type === "image" ? (
          <img key={index} src={slide.url} alt={`slide-${index}`} />
        ) : (
          <video key={index} src={slide.url} controls autoPlay loop muted />
        ),
      )}
    </div>
  );
}

export default Slider;
